// import Vue from 'vue'

import i18n from '@/i18n'

const PRODUCTS_UPDATED = (state, envelope) => {
  state.products = envelope.results
  state.totalCount = envelope.total
  state.filter.page = envelope.page
  state.page = envelope.page

  if (envelope.total > 0) {
    let aggregation = envelope.aggregation.metrics
    if (aggregation) {
      let minValue = aggregation.find(f => f.name === 'Price_Min')
      let maxValue = aggregation.find(f => f.name === 'Price_Max')
      if (minValue && maxValue) {
        let newMinPrice = minValue.value
        let newMaxPrice = maxValue.value

        if (newMinPrice < newMaxPrice) {
          if (!state.filter.minPrice || state.filter.minPrice > newMinPrice) {
            state.filter.minPrice = newMinPrice
            state.filter.priceArray = []
          }
          if (state.filter.maxPrice < newMaxPrice) {
            state.filter.maxPrice = newMaxPrice
          }
        }
      }

      let nightMinValue = aggregation.find(f => f.name === 'Nights_Min')
      let nightMaxValue = aggregation.find(f => f.name === 'Nights_Max')
      if (nightMinValue && nightMaxValue) {
        let newMinNights = nightMinValue.value
        let newMaxNights = nightMaxValue.value

        if (newMinNights < newMaxNights) {
          if (state.filter.maxNights < newMaxNights) {
            state.filter.maxNights = newMaxNights
          }
          if (
            !state.filter.minNights ||
            state.filter.minNights > newMinNights
          ) {
            state.filter.minNights = newMinNights
          }
        }
      }
    }

    if (
      envelope.aggregation &&
      envelope.aggregation.tags &&
      envelope.aggregation.tags.length > 0
    ) {
      let groupedTags = envelope.aggregation.tags.reduce((rv, x) => {
        if (!rv[x['name']]) rv[x['name']] = []
        rv[x['name']].push(x['value'])
        return rv
      }, {})

      state.available_tags = groupedTags
    } else {
      state.available_tags = {}
    }
  }
}

const THEMES_RECEIVED = (state, themes) => {
  state.themes = themes
}

const TAG_ADDED = (state, tag) => {
  if (state.filter.tags && !state.filter.tags.includes(tag)) {
    state.filter.tags.push(tag)
  }
}

const TAG_REMOVED = (state, tag) => {
  state.filter.tags = state.filter.tags.filter(f => f != tag)
  state.filter.text = state.filter.text
    .split(' ')
    .filter(f => f != tag)
    .join(' ')
}

const SEARCH_TYPE_CHANGED = (state, type) => {
  switch (type.name) {
    case 'theme':
      state.filter.countries = []
      state.filter.themes = []
      state.filter.themes.push(type.id)
      state.title = i18n.t('general.search')
      break
    case 'country':
      state.filter.countries = []
      state.filter.themes = []
      state.filter.countries.push(type.id)
      state.title = i18n.t('general.hotels-in')
      break
    case 'keyword':
      state.filter.countries = []
      state.filter.themes = []
      state.filter.text = type.keyword
      state.title = i18n.t('general.search')
      break
    default:
      state.filter.countries = []
      state.filter.themes = []
      state.title = i18n.t('general.search')
      break
  }
  state.page = 1
  state.filter.page = 1
}

const RESET_SEARCH = state => {
  state.filter = {
    text: '',
    minNights: null,
    maxNights: null,
    minPrice: null,
    maxPrice: null,
    categories: [],
    themes: [],
    sortBy: 'weRecommend',
    countries: [],
    page: 1,
    pageSize: 18,
    nightsArray: [],
    priceArray: [],
    tags: [],
  }
}

const RESET_SEARCHTEXT = state => {
  state.filter.text = ''
}

const SORT_BY_UPDATED = (state, sort) => {
  state.filter.sortBy = sort
}

const FILTER_UPDATED = (state, filter) => {
  if (filter) {
    if (filter.text && filter.text.length > 0) {
      state.filter.text = filter.text
    }

    if (filter.minNights && filter.minNights > 0) {
      state.filter.minNights = parseInt(filter.minNights)
    }
    if (filter.maxNights && filter.maxNights > 0) {
      state.filter.maxNights = parseInt(filter.maxNights)
    }
    if (filter.minPrice && filter.minPrice > 0) {
      state.filter.minPrice = parseInt(filter.minPrice)
    }
    if (filter.maxPrice && filter.maxPrice > 0) {
      state.filter.maxPrice = parseInt(filter.maxPrice)
    }
    if (filter.categories && filter.categories.length > 0) {
      if (Array.isArray(filter.categories)) {
        state.filter.categories = filter.categories
      } else {
        state.filter.categories = []
        state.filter.categories.push(filter.categories)
      }
    }

    if (filter.tags && filter.tags.length > 0) {
      if (Array.isArray(filter.tags)) {
        state.filter.tags = filter.tags
      } else {
        state.filter.tags = []
        state.filter.tags.push(filter.tags)
      }
    }

    if (filter.themes) {
      state.filter.themes = filter.themes
    }
    if (filter.sortBy) {
      state.filter.sortBy = filter.sortBy
    }
    if (filter.countries) {
      state.filter.countries = filter.countries
    }
    if (filter.page && filter.page > 0) {
      state.filter.page = parseInt(filter.page)
    }
    if (filter.pageSize && filter.pageSize > 0) {
      state.filter.pageSize = parseInt(filter.pageSize)
    }
  }
}

const TAGS_UPDATED = (state, tags) => {
  state.filter.tags = tags
}

export default {
  PRODUCTS_UPDATED,
  THEMES_RECEIVED,
  SEARCH_TYPE_CHANGED,
  RESET_SEARCH,
  RESET_SEARCHTEXT,
  FILTER_UPDATED,
  TAG_ADDED,
  TAG_REMOVED,
  TAGS_UPDATED,
  SORT_BY_UPDATED,
}
